export const equipment = [
  {
    "NEW & FEATURED": [
      "Best Sellers",
      "Gym Training",
      "Glove Finder",
      "Noya Athletic X Muhammad Ali",
    ],
    BOXING: [
      "Fight Gloves",
      "Training Gloves",
      "Youth Equipment",
      "Bags & Stands",
      "Protective Gear",
      "Coaching Equipment",
      "Hand Wraps",
      "Footwear",
      "Boxing Rings & Accesories",
      "Boxing Apparel",
    ],
    MMA: [
      "Gloves",
      "Bags & Stands",
      "Protective Gear",
      "Coaching Equipment",
      "Training Apparel",
      "Cages & Accessories",
    ],
    "TRAINING & FITNESS": [
      "Strength & Performance",
      "Conditioning",
      "Fitness Gloves",
      "Jump Ropes",
    ],
    COLLECTIONS: [
      "MX",
      "Protex",
      "1910",
      "Powerlock",
      "Elite",
      "Spark",
      "Core",
      "Titan",
      "Prospect",
      "Noya Athletic X",
      "Limited Edition",
    ],
  },
];

export const apparel = [
  {
    "ALL APPAREL": [
      "Noya Athletic X Muhammad Ali",
      "Training Apparel",
      "Lifestyle",
      "Varsity",
      "Boxing Academy",
      "Athleisure",
      "Competition Apparel",
      "Coaching And Corner Kits",
      "Tops & T-Shirts",
      "Hoodies & Sweats",
      "Outwear",
      "Pants & Shorts",
    ],
    MEN: [
      "Tees & Tanks",
      "Shorts",
      "Pants",
      "Tights",
      "Hoodies",
      "Jackets",
      "Competition",
      "Lifestyle",
    ],
    WOMEN: [
      "Tees & Tanks",
      "Shorts",
      "Bottoms",
      "Leggings",
      "Sports Bras",
      "Jackets",
      "Lifestyle",
    ],
    "TRAINING APPAREL": [
      "Sauna Suits",
      "Slimmer Belts",
      "Support Belts",
      "Gym Bags & Backpacks",
      "Weighted Vest",
      "Accesories",
    ],
  },
];

export const footwear = [
  {
    "ALL FOOTWEAR": [
      "Elite Boxing Shoes",
      "Powerlock X Trainers",
      "PIVT Boxing Shoes",
      "Slides",
      "Socks",
      "Shoes $100 And Under",
    ],
    "SHOE TYPE": ["Low-Top Shoes", "Mid-Top Shoes", "High-Top Shoes"],
  },
];
